<template>
    <el-select
      v-model="data"
      filterable
      remote
      reserve-keyword
      clearable
      :placeholder="placeholder"
      :multiple="multiple"
      :disabled="disabled"
      :remote-method="search"
      :loading="loading"
      :multiple-limit="limit"
      :allow-create="allowCreate"
      value-key="id"
      @visible-change="visibleChange"
      @remove-tag="removeTag"
      @change="onChange"
      @clear= clear
    >
      <el-option
        v-for="(item) in options"
        :key="item.id"
        :label="item.name"
        :value="item">
      </el-option>
    </el-select>
</template>
<script>
import { getAreaCity } from '@/api/base';
export default{
  name: 'AreaAutoComplete',
  props: {
      value: [Number, String, Array],
      limit: {
          type: Number,
          default: 20
      },
      initChooseFirst: {
          type: Boolean,
          default: false
      },
      placeholder: {
          type: String,
          default: '请输入意向区域'
      },
      disabled: {
          type: Boolean,
          default: false
      },
      // 是否支持多选
      multiple: {
          type: Boolean,
          default: false
      },
      limit: {
          type: Number,
          default: 3
      },
      allowCreate: {
        type: Boolean,
        default: false
      }
  },
  data() {
    return {
        data: [],
        loading: false,
        searchTimeOutHandle: null,
        options: [],
        multipleSelected: []
    }
  },
  watch: {
    value(val) {
        if (this.multiple && typeof val !== 'object') val = [val];
        if (this.multiple && val.join(',') !== this.data.join(',')) {
            this.data = val;
            this.options = val;
        } else if (!this.multiple && val !== this.data.id) {
            this.search(val)
        }
    }
  },
  created() {
    if ((this.multiple && this.value && this.value.length > 0) || (!this.multiple && this.value)) {
        if (this.multiple) this.data = this.value;
        this.search(this.value, true)
    }
  },
  methods: {
    search(query, isInit = false) {
        this.loading = true;
        clearTimeout(this.searchTimeOutHandle);
        let conditions = {
            limit: this.limit ?? 10
        }
        if (typeof query === 'object') {
          conditions.id = query.map( (v) =>v.id).join(',')
        } else if (!!query) {
          if (/^\d+$/.test(query) === true) {
            conditions.id = query
          } else {
            conditions.name = query
          }
        }
        conditions.type = 2;
        let that = this;
        let timeout = isInit ? 0 : 300;
        this.searchTimeOutHandle = setTimeout(() => {
            getAreaCity(conditions).then(response => {
                that.loading = false;
                that.options = response;
                that.data = that.multiple ? that.data : null;
                if (response.length > 0) {
                    if (!!that.value && !that.multiple) {
                        that.options.forEach(item => {
                            if (item.id == that.value) {
                                that.data = that.value
                            }
                        })
                    } else if (!!that.value && that.value[0] && that.multiple) {
                        const unRepeat = that.multipleSelected.filter(v => that.options.findIndex(m => m.id == v.id) < 0);
                        that.options = [...unRepeat, ...that.options];
                        const list = that.options.filter(v => {
                          return (isInit ? that.value : that.data).findIndex(m => `${m.id}` == `${v.id}`) >= 0
                        });
                        if(list.length){
                          that.data = list
                        }
                        if (isInit) this.multipleSelected = list;
                    } else if (that.initChooseFirst) {
                        that.data = response[0].id
                    }
                }
                !that.multiple && that.onChange();
                if (isInit) {
                    that.$emit('created', that.data);
                }
            }).catch(err => {
                that.loading = false;
            })
        }, timeout);
      },
      onChange(item) {
        if (!this.multiple) {
            let data = this.data;
            if (this.multiple) {
                data = data.join(',');
            }
            this.$emit('input', data);
        } else {
            this.multipleSelected = this.data.map(v => {
                const value = this.options.find(m => m.id == v);
                return value
            })
        }
      },
      clear () {
        if (this.multiple) {
            this.multipleSelected = [];
            this.$emit('input', []);
        }
      },
      onClean() {
        this.options = [];
        this.data = null;
        this.multipleSelected = [];
        this.$emit('input', '');
      },
      visibleChange (status) {
        if (!this.multiple || status) return null;
        this.$emit('input', this.data);
      },
      removeTag (val) {
        this.$emit('input', this.data);
      }
  }
}
</script>
